import React from "react";
import { SocialPostData } from "../types";
import ScheduleDateTimeField from "../../../Shared/ScheduleDateTimeField";

interface ScheduleModalProps {
  isOpen: boolean;
  onClose: () => void;
  scheduleDateTime: string;
  onDateTimeChange: (dateTime: string) => void;
  scheduleTimezone: string;
  onTimezoneChange: (tz: string) => void;
  selectedPostData: SocialPostData | null;
  onSchedule: () => void;
  isScheduling: boolean;
}

export const ScheduleModal: React.FC<ScheduleModalProps> = ({
  isOpen,
  onClose,
  scheduleDateTime,
  onDateTimeChange,
  scheduleTimezone,
  onTimezoneChange,
  selectedPostData,
  onSchedule,
  isScheduling,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-theme-surface rounded-lg p-6 max-w-md w-full mx-4 shadow-xl border border-theme-border"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold text-theme-fg mb-4">
          Schedule Social Post
        </h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-theme-fg mb-2">
              Select Date & Time
            </label>
            <ScheduleDateTimeField
              value={scheduleDateTime}
              onChange={onDateTimeChange}
              timezone={scheduleTimezone}
              onTimezoneChange={onTimezoneChange}
            />
          </div>
          {selectedPostData && (
            <div className="bg-theme-background p-3 rounded-lg border border-theme-border">
              <p className="text-sm text-theme-fg-muted mb-1">Post Preview:</p>
              <p className="text-sm text-theme-fg line-clamp-2">
                {selectedPostData.content || "No content"}
              </p>
              {selectedPostData.platforms && (
                <p className="text-xs text-theme-fg-muted mt-1">
                  Platforms: {selectedPostData.platforms.join(", ")}
                </p>
              )}
            </div>
          )}
          <div className="flex gap-3 justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 text-theme-fg border border-theme-border rounded-lg hover:bg-theme-background transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onSchedule}
              disabled={!scheduleDateTime || isScheduling}
              className="px-4 py-2 bg-theme-primary text-white rounded-lg hover:bg-theme-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isScheduling ? (
                <>
                  <svg
                    className="animate-spin h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Scheduling...
                </>
              ) : (
                "Schedule Post"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
